var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-container-fluid flix-html-html",staticStyle:{"margin-top":"20px","background-color":"#ddd","color":"#000"}},[_c('div',{staticClass:"flix-container",staticStyle:{"padding":"50px 0"}},[(_vm.data)?_c('div',{staticClass:"flix-form-group",domProps:{"innerHTML":_vm._s(_vm.getText())}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }